import SocialDistanceIcon from '@mui/icons-material/SocialDistance';

import { RaModule } from 'resources/RaModule';
import { ResourceName, ResourceIntent } from 'shared/enums';

import { ReferralCreate } from './pages/ReferralCreate.component';
import { ReferralEdit } from './pages/ReferralEdit.component';
import { ReferralList } from './pages/ReferralList.component';
import { ReferralShow } from './pages/ReferralShow.component';
import { ResourceComponentProps } from 'react-admin';

const allowExtendedReferralInfo = false;

export const ReferralsModule = RaModule.fromResourceProps({
  name: ResourceName.REFERRALS,
  intent: ResourceIntent.ROUTE,
  options: { label: 'Referrals' },
  create: allowExtendedReferralInfo ? ReferralCreate : undefined,
  list: (props: ResourceComponentProps) =>
    ReferralList({ ...props, allowExtendedReferralInfo }),
  show: allowExtendedReferralInfo ? ReferralShow : undefined,
  edit: allowExtendedReferralInfo ? ReferralEdit : undefined,
  icon: SocialDistanceIcon
});
